import {
  GET_MODERATION_REPORTS,
  REMOVE_MODERATION_REPORT,
  UPDATE_MODERATION_REPORT
} from '../actions/types';

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_MODERATION_REPORTS: {
      return [...action.payload.moderationReports];
    }
    case REMOVE_MODERATION_REPORT: {
      return state.filter(report => report.id !== action.payload.promptID);
    }
    // hiding or unhiding a prompt does not touch its report, so the row is
    // patched in place rather than refetched - the admin keeps their scroll
    // position while working through the queue
    case UPDATE_MODERATION_REPORT: {
      const { promptID, changes } = action.payload;
      return state.map(report =>
        report.id === promptID ? { ...report, ...changes } : report
      );
    }
    default:
      return state;
  }
}
